// IMPORT
const THREE = require('three')
import store from 'src/store'
import {TimelineMax, Cubic, CustomWiggle, TweenMax} from 'gsap'
import {config as gameConfig} from './config'
import * as clock from './clock'
// import music from './music'
import game from './main'


// CAMERA
export let camera = new THREE.PerspectiveCamera(
  30,
  window.innerWidth / window.innerHeight,
  0.1,
  20000 * gameConfig.worldScale
)
export default camera



// RESIZE
const updateAspect = function () {
  camera.aspect = store.state.browser.windowWidth / store.state.browser.windowHeight
  camera.updateProjectionMatrix()
}
store.watch(function (state) {
  return store.state.browser.windowWidth
}, updateAspect)
store.watch(function (state) {
  return store.state.browser.windowHeight
}, updateAspect)


// INIT
// camera.position.z = -100 // 3RD PERSON
camera.position.y = 2.25 * gameConfig.worldScale
camera.rotation.y = THREE.Math.DEG2RAD * -180
// camera.rotation.x = THREE.Math.DEG2RAD * 90



// UPDATE
let camState = {
  velocityPercent: 0,
  currDirection: 0,
  turnTime: 1.5,

  playBreath: true
}
// let velocityPercent = 0
// let currDirection = 0
let angles = {
  curr: 0,
  goal: 0,
  offset: 0
}

export const update = function (state, controls, trackAngles) {
  camState.velocityPercent = state.velocity.percent
  const timeScale = 0.2 + (camState.velocityPercent) * 1 * controls.state.multiplier
  tl.timeScale(timeScale)


  // ROTATE CAM
  camState.currDirection = trackAngles[0]
  let multiplier = 15 + state.velocity.percent * 10
  let z = 0
  switch (camState.currDirection) {
    case 90:
      z = -multiplier
      break
    case -90:
      z = multiplier
      break
    default:
      z = 0
      break
  }
  angles.goal = z

  let delta = clock.state.delta

  if (angles.curr > angles.goal) {
    angles.curr -= (multiplier / camState.turnTime) * delta
  } else if (angles.curr < angles.goal) {
    angles.curr += (multiplier / camState.turnTime) * delta
  }

  // console.log(angles.offset)
  camera.rotation.z = (angles.curr + angles.offset) * THREE.Math.DEG2RAD

}


export let tl = new TimelineMax({paused: true})
camera.rotation.y -= 0.015
camera.rotation.offset = -0.015
tl
  .to(camera.rotation, 0.2, {
    y: '+=' + 0.03,
    offset: '+=' + 0.03,
    repeat: -1,
    yoyo: true,
    ease: Cubic.easeInOut,
    onUpdateParams: ['{self}'],
    onUpdate: (tween)=> {
      angles.offset = tween.target.offset / THREE.Math.DEG2RAD
    },
    onRepeat: ()=> {
      playStep()
      stepCount += 1
      if (stepCount >= 4) {
        stepCount = 0
        playBreath()
      }
    }
  })


camera.update = update
camera.playStep = playStep
camera.tl = tl


camera.startRun = function () {
  camera.tl.play()
}
camera.stopRun = function () {
  camera.tl.pause()
}



let stepCount = 0
export const playBreath = function () {
  let i = Math.round(Math.random() * 3)
  let key = `breath${i}`
  let audio = game.sounds[key].audio
  if (!audio) return
  audio.stop()
  audio.setVolume(game.sounds[key].volume || 1)
  audio.play()
}

let stepDirection = 'L'
let stepIdx = 0
export const playStep = function () {
  if (stepDirection === 'L') stepIdx = Math.round(Math.random() * 2) // RANDOM
  stepDirection = stepDirection === 'L' ? 'R' : 'L'
  let key = `step${stepDirection}${stepIdx}`
  let audio = game.sounds[key].audio
  if (!audio) return
  audio.stop()
  audio.setVolume(game.sounds[key].volume || 1)
  audio.play()
}







// WEBPACK FOOTER //
// ./src/components/game/camera.js